<template>
  <div class="uk-flex uk-flex-middle" uk-height-viewport>
    <div class="uk-width-3-3@m uk-width-1-3@s m-auto rounded">
      <div class="uk-child-width-2-2@m uk-grid-collapse" uk-grid>
        <div class="uk-card-default p-5 rounded">
          <div class="mb-4">
            <h3 class="mb-3"> {{ $t('register.header') }}</h3>
            <div v-if="errors" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;"><i class="uil-exclamation-triangle"></i> {{ errors }}</p>
            </div>

            <div v-if="message" class="uk-alert-success" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:green;"><i class="uil-exclamation-triangle"></i> {{ message }}
              </p>
            </div>
          </div>
          <form>
            <div class="uk-grid-small uk-child-width-1-2" uk-grid>
              <div class="uk-width-1-2">
                <div class="uk-form-group">
                  <label class="uk-form-label"> {{ $t('register.name') }}</label>
                  <div class="uk-position-relative w-100">
                    <span class="uk-form-icon">
                      <i class="icon-feather-user"></i>
                    </span>
                    <input v-model="form.name" class="uk-input" required type="text">
                  </div>
                </div>
              </div>
              <div class="uk-width-1-2">
                <div class="uk-form-group">
                  <label class="uk-form-label"> {{ $t('register.surname') }}</label>
                  <div class="uk-position-relative w-100">
                    <span class="uk-form-icon">
                      <i class="icon-feather-user"></i>
                    </span>
                    <input v-model="form.surname" class="uk-input" required type="text">
                  </div>
                </div>
              </div>

            </div>

            <div class="uk-form-group">
              <label class="uk-form-label"> {{ $t('register.phone') }}</label>
              <div class="uk-position-relative w-100">
                <PhoneInput v-model="form.phone" :country-phone-code="form.country_phone_code" name="phone" />
              </div>
            </div>

            <div class="uk-form-group">
              <label class="uk-form-label"> {{ $t('register.email') }}</label>
              <div class="uk-position-relative w-100">
                <span class="uk-form-icon">
                  <i class="icon-feather-mail"></i>
                </span>
                <input v-model="form.email" class="uk-input" required type="email">
              </div>
            </div>

            <div class="password-validation-area">
              <password-validation :password="form.password" :passwordConfirmation="form.password_confirmation"
                @update:password="form.password = $event"
                @update:passwordConfirmation="form.password_confirmation = $event"
                @update:isMatched="isPasswordsMatched = $event" />
            </div>

            <div class="mt-4 uk-flex-middle uk-grid-small" uk-grid>
              <div class="uk-width-auto@s">
                <button :disabled="isSubmitting" class="btn btn-warning mr-2"
                  style="background-color: #ffab00 !important; color: #ffffff !important; border-color: #ffab00 !important; opacity: 1 !important;"
                  type="button" @click="$router.push({ name: 'login' })">
                  {{ $t('general.cancel') }}
                </button>
                <button :disabled="!isFormFilled || isSubmitting" class="btn btn-default" type="button"
                  @click.prevent="onSubmit()">
                  <template v-if="isSubmitting">
                    <ProcessingDots />
                  </template>
                  <template v-else>
                    {{ $t('general.save') }}
                  </template>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { SET_ERROR, REGISTER, ERROR } from "@/core/services/store/auth.module";
import store from "@/core/services";
import { DomainMapper } from "@/core/config/domain-mapper";
import PhoneInput from "@/assets/components/inputs/PhoneInput.vue";
import PasswordValidation from "@/view/components/validation/PasswordValidation.vue";
import ProcessingDots from "@/view/components/loading/ProcessingDots.vue";

export default {
  name: "ForgotPassword",
  components: {
    PhoneInput,
    PasswordValidation,
    ProcessingDots
  },
  data() {
    return {
      form: {
        name: '',
        surname: '',
        password: '',
        phone: '',
        password_confirmation: '',
        email: null,
        alias: process.env.VUE_APP_DEFAULT_SUBDOMAIN,
        country_phone_code: ''
      },
      message: null,
      errorMessages: [],
      isSubmitting: false,
      isPasswordsMatched: false,
    }
  },
  computed: {
    errors() {
      return store.getters[ERROR];
    },
    isFormFilled() {
      return this.form.name &&
        this.form.surname &&
        this.form.phone &&
        this.form.email &&
        this.isPasswordsMatched
    },
  },
  watch: {
    errors(newError, oldError) {
      if (newError && newError !== oldError) {
        this.isSubmitting = false;
      }
    }
  },
  methods: {
    onSubmit() {
      if (!this.isFormFilled) {
        return;
      }

      this.isSubmitting = true;
      this.message = null;

      this.form.alias = process.env.VUE_APP_DEFAULT_SUBDOMAIN;

      // Önceki hataları temizle
      this.$store.commit(SET_ERROR, null);

      this.form.country_phone_code = this.form.phone.substring(0, this.form.phone.indexOf(' ')).substring(1);
      this.form.phone = this.form.phone.substring(this.form.phone.indexOf(' ') + 1).replaceAll(' ', '');

      if (window.location.hostname !== 'localhost') {
        // www önekini kaldır ve doğru subdomain'i al
        let hostname = window.location.hostname;
        let parts = hostname.split(".");

        // www.oktayanzeralife.zorunluegitimler.com -> oktayanzeralife
        // oktayanzeralife.zorunluegitimler.com -> oktayanzeralife
        if (parts[0] === 'www' && parts.length > 1) {
          this.form.alias = parts[1];
        } else {
          this.form.alias = parts[0];
        }

        if (["production"].includes(process.env.NODE_ENV) && DomainMapper.hasOwnProperty(hostname)) {
          this.form.alias = DomainMapper[hostname] || this.form.alias;
        }
      }

      this.form.phone = this.form.phone.replace(" ", "");

      this.$store.dispatch(REGISTER, this.form)
        .then((response) => {
          // Eğer email doğrulanmamışsa email verification sayfasına yönlendir
          if (!response.is_verify) {
            this.$router.push({
              name: 'index.email-verification',
              query: {
                email: response.email,
                token: response.token,
                alias: this.form.alias
              }
            });
          } else {
            this.message = this.$t('register.register_successful')
            setTimeout(() => this.$router.push({ name: 'login' }), 1000);
          }
        })
        .catch(() => { })
        .finally(() => {
          this.isSubmitting = false;
        })
    }
  },
  mounted() {
    this.$store.commit(SET_ERROR, '')
  }
}
</script>

<style>
.password-validation-area {
  .password-validation {
    display: flex;
    flex-direction: column;
    padding: initial !important;
  }

  .uk-form-group :deep(.uk-child-width-1-2\@s)>* {
    width: 100% !important;
  }

  .uk-first-column {
    width: 100% !important;
  }
}

/* ProcessingDots   */
.btn :deep(.processing-dots) {
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn :deep(.processing-dots span) {
  background-color: #ffffff;
}
</style>
